export default "__VITE_ASSET__5f5b6ced__"